export enum AppType {
  BigRoad = 'BigRoad',
  CargoChief = 'CargoChief',
  ConvoyTracking = 'ConvoyTracking',
  Coretex = 'Coretex',
  ERoad = 'ERoad',
  EmailRateConfirmation = 'EmailRateConfirmation',
  FleetComplete = 'FleetComplete',
  FleetLocate = 'FleetLocate',
  FourKitesCarrier = 'FourKitesCarrier',
  FourKitesCustomer = 'FourKitesCustomer',
  GeoTab = 'GeoTab',
  Greenscreens = 'Greenscreens',
  Highway = 'Highway',
  Hirschbach = 'Hirschbach',
  Hutch = 'Hutch',
  ISAAC = 'ISAAC',
  McLeod = 'McLeod',
  Mercurygate = 'Mercurygate',
  MondoTracking = 'MondoTracking',
  Motive = 'Motive',
  MyCarrierPortal = 'MyCarrierPortal',
  OneStepGPS = 'OneStepGPS',
  Orbcomm = 'Orbcomm',
  Project44 = 'Project44',
  RMIS = 'RMIS',
  RevenovaProduction = 'RevenovaProduction',
  RevenovaSandbox = 'RevenovaSandbox',
  SFTP = 'SFTP',
  Samsara = 'Samsara',
  Sonar = 'Sonar',
  TQLTrax = 'TQLTrax',
  Tai = 'Tai',
  Tailwind = 'Tailwind',
  ThreeGTMS = 'ThreeGTMS',
  Tive = 'Tive',
  Turvo = 'Turvo',
  Txt = 'TXT Solutions',
  US1NetworkTMS = 'US1NetworkTMS',
  VerizonConnectFleetTelogis = 'VerizonConnectFleetTelogis',
  VerizonConnectReveal = 'VerizonConnectReveal'
}

export enum AppCategories {
  CarrierVetting = 'Carrier Vetting',
  DeviceTracker = 'Device Tracker',
  ELD = 'ELD',
  Rating = 'Rating',
  TMS = 'TMS',
  TemperatureMonitoring = 'Temperature Monitoring',
  ThirdPartyCarrierTrackingAPI = 'Third Party Carrier Tracking API',
  TrailerTracking = 'Trailer Tracking',
  VisibilityProvider = 'Visibility Provider'
}
